export default __webpack_public_path__ + "images/32592b8c-logout.svg";